import axios from 'axios';

const api = axios.create({
  baseURL: 'https://solplanet.tecnologiacharra.com/api',
});

// Request interceptor to attach JWT token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('solplanet_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

// Response interceptor to handle token expiration or unauthorized access
api.interceptors.response.use((response) => {
  return response;
}, (error) => {
  if (error.response && error.response.status === 401) {
    // Optionally trigger a logout if token is invalid/expired
    localStorage.removeItem('solplanet_token');
    window.location.href = '/login';
  }
  return Promise.reject(error);
});

export default api;
